import { INDIAN_TIMEZONE } from '@/shared/utils/dateTime'

export interface OverdueFollowupEntry {
  id: string
  title: string
  type: string
  priority: string
  dueAt: string
  notes: string
  rep: string
}

export interface OverdueRow {
  followup: OverdueFollowupEntry
  lead: {
    _id: string
    name: string
    company?: string
    email?: string
    phone?: string
    assignee?: string
    source?: string
    status?: string
    value?: number
    interest?: string
    industry?: string
  }
}

const DAY_MS = 86_400_000

// A follow-up only ever reaches this list once its due date has passed, so the
// age of the miss is what a rep should see first.
export function daysOverdue(dueAt: string, now: Date = new Date()): number {
  return Math.max(0, Math.floor((now.getTime() - new Date(dueAt).getTime()) / DAY_MS))
}

export function overdueLabel(dueAt: string, now: Date = new Date()): string {
  const days = daysOverdue(dueAt, now)
  if (days < 1) return 'Overdue today'
  return days === 1 ? '1 day overdue' : `${days} days overdue`
}

export function formatFollowupDue(dueAt: string): string {
  const date = new Date(dueAt)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: INDIAN_TIMEZONE,
  })
}

const PRIORITY_BADGE: Record<string, string> = {
  High: 'bg-orange-500/10 text-orange-600 dark:text-orange-400',
  Normal: 'bg-slate-500/10 text-slate-600 dark:text-slate-300',
  Low: 'bg-blue-400/10 text-blue-600 dark:text-blue-400',
}

export function priorityBadgeClass(priority?: string): string {
  return PRIORITY_BADGE[priority || 'Normal'] || PRIORITY_BADGE.Normal
}

export function formatLeadValue(value?: number): string {
  return typeof value === 'number' ? `₹${value.toLocaleString()}` : '₹0'
}
